var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderingUx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_902_981)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_902_981",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 56,
    height: 56
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.05176e-05 3.8147e-06H56V56H3.05176e-05V3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_902_981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.09378 34.0156H54.9063V7.76563C54.9063 5.34953 52.9474 3.39063 50.5313 3.39063H5.46878C3.05269 3.39063 1.09378 5.34953 1.09378 7.76563V34.0156Z",
    stroke: "#262626",
    strokeWidth: 2.1875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9063 34.0156V37.2969C54.9063 39.713 52.9474 41.6719 50.5313 41.6719H5.46878C3.05269 41.6719 1.09378 39.713 1.09378 37.2969V34.0156H54.9063Z",
    stroke: "#262626",
    strokeWidth: 2.1875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0547 11.2656H46.1016",
    stroke: "#262626",
    strokeWidth: 2.1875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0547 16.9531H46.1016",
    stroke: "#262626",
    strokeWidth: 2.1875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.086 22.6406H46.1016",
    stroke: "#262626",
    strokeWidth: 2.1875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0547 28.3281H46.1016",
    stroke: "#262626",
    strokeWidth: 2.1875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.6563 47.6875H32.9219V41.6719H23.0782V47.6875H20.3438C17.9276 47.6875 15.9688 49.6463 15.9688 52.0625V52.6094H40.0313V52.0625C40.0313 49.6463 38.0725 47.6875 35.6563 47.6875Z",
    stroke: "#262626",
    strokeWidth: 2.1875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7657 14.2734L14.7657 22.9141L7.76566 14.2734H21.7657Z",
    stroke: "#262626",
    strokeWidth: 2.1875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7969 22.4847L28.0033 23.7891L29.4219 20.9453",
    stroke: "#262626",
    strokeWidth: 2.1875,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_902_981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderingUx);
export default __webpack_public_path__ + "static/media/ordering-ux.a4b9800b23e0419f8076dc5c15c1b8e2.svg";
export { ForwardRef as ReactComponent };